exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cintillo__notification[data-v-b1386acc]{width:100%;height:16vh;background-color:red}", ""]);

// exports
